import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';

import ConnectedButton from "./ConnectedButton";
import { AppTopbarProfile } from './AppTopbarProfile';

export const AppTopbar = (props) => {
    const history = useHistory();
    const [yesNo, setYesNo] = useState({});
    const [displayBasic, setDisplayBasic] = useState(false);
    const [displayPosition, setDisplayPosition] = useState(false);
    const [position, setPosition] = useState('center');
    const op2 = useRef(null);

    const dialogFuncMap = {
        'displayBasic': setDisplayBasic,
        'displayPosition': setDisplayPosition,
    }

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);
        if (position) {
            setPosition(position);
        }
    }

    const toggle = (event) => {
        op2.current.toggle(event);
    };

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    let dataUser = localStorage.getItem('user');
    let recup = JSON.parse(dataUser);
    let user = recup?.utilisateur;

    let firstLettre = user?.nom;
    let secondLettre = user?.prenom;

    const logout = () => {
        setYesNo({
            visible: true,
            message: "Voulez-vous vraiment se déconnecter ?",
            hide: () => setYesNo((prev) => ({ ...prev, visible: false })),
            callback: () => {
                localStorage.clear('token');
                history.push("/login");
            }
        })
    }

    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">

                <span>GESTION DU PARC &nbsp; </span>
                <i className="pi pi-car"></i>
            </Link>

            <Confirmation {...yesNo} />

            <AppTopbarProfile ref={op2} user={user}/>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button"
                onClick={props.onToggleMenuClick} >
                <i className="pi pi-bars" />
            </button>

            <button type="button" className="p-link layout-topbar-menu-button 
                layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul className={classNames("layout-topbar-menu lg:flex origin-top",
                { 'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>
                <li>
                    <Button label={secondLettre?.charAt(0) /*+ firstLettre.charAt(0)*/}
                        className="p-button-rounded p-button-warning mr-2 mb-2"
                        onClick={(e) => {
                            onClick('displayPosition', 'top-right');
                            toggle(e);
                        }} />
                </li>
                <li>
                    <Button className='p-button-rounded p-button-danger mr-2 mb-2'
                        icon='pi pi-power-off' onClick={logout} />
                </li>
            </ul>
        </div>
    );
}

const Confirmation = (props) => {
    const { visible, hide, message, callback } = props;

    return (
        <Dialog modal visible={visible} onHide={hide}
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times"
                        onClick={hide}
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check"
                        onClick={() => { hide(); callback() }}
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
} 
